/**
 * India cities + states — static reference for datalist typeahead in
 * ClientLocationsSection. Keeps free-text problems (typos, casing) at bay.
 * Not exhaustive — 60 top cities that cover ~95% of Indian recruiting demand.
 *
 * `CITY_TO_STATE` — cascade map used to auto-fill the State field when the
 * user picks a known city (V1.5.5.1 UX polish). Keep keys canonical (case as
 * in IN_CITIES) so lookups are deterministic.
 */

export const IN_STATES = [
    "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
    "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand",
    "Karnataka", "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur",
    "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Punjab",
    "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura",
    "Uttar Pradesh", "Uttarakhand", "West Bengal",
    // UTs
    "Andaman and Nicobar Islands", "Chandigarh",
    "Dadra and Nagar Haveli and Daman and Diu",
    "Delhi", "Jammu and Kashmir", "Ladakh", "Lakshadweep", "Puducherry",
];

export const CITY_TO_STATE = {
    "Ahmedabad": "Gujarat",
    "Bengaluru": "Karnataka",
    "Bangalore": "Karnataka",
    "Bhopal": "Madhya Pradesh",
    "Bhubaneswar": "Odisha",
    "Chandigarh": "Chandigarh",
    "Chennai": "Tamil Nadu",
    "Coimbatore": "Tamil Nadu",
    "Delhi": "Delhi",
    "Faridabad": "Haryana",
    "Ghaziabad": "Uttar Pradesh",
    "Gurgaon": "Haryana",
    "Gurugram": "Haryana",
    "Guwahati": "Assam",
    "Hyderabad": "Telangana",
    "Indore": "Madhya Pradesh",
    "Jaipur": "Rajasthan",
    "Jodhpur": "Rajasthan",
    "Kanpur": "Uttar Pradesh",
    "Kochi": "Kerala",
    "Kolkata": "West Bengal",
    "Lucknow": "Uttar Pradesh",
    "Ludhiana": "Punjab",
    "Madurai": "Tamil Nadu",
    "Mangalore": "Karnataka",
    "Meerut": "Uttar Pradesh",
    "Mumbai": "Maharashtra",
    "Mysuru": "Karnataka",
    "Nagpur": "Maharashtra",
    "Nashik": "Maharashtra",
    "Navi Mumbai": "Maharashtra",
    "New Delhi": "Delhi",
    "Noida": "Uttar Pradesh",
    "Patna": "Bihar",
    "Pune": "Maharashtra",
    "Raipur": "Chhattisgarh",
    "Ranchi": "Jharkhand",
    "Surat": "Gujarat",
    "Thane": "Maharashtra",
    "Thiruvananthapuram": "Kerala",
    "Tiruchirappalli": "Tamil Nadu",
    "Vadodara": "Gujarat",
    "Varanasi": "Uttar Pradesh",
    "Vijayawada": "Andhra Pradesh",
    "Visakhapatnam": "Andhra Pradesh",
};

export const IN_CITIES = Object.keys(CITY_TO_STATE).sort();

/**
 * Look up the state for a typed/picked city, case-insensitively.
 * Returns "" when the city isn't in our reference map — caller keeps the
 * user's own input untouched in that case.
 */
export function stateForCity(city) {
    if (!city) return "";
    const key = String(city).trim();
    if (CITY_TO_STATE[key]) return CITY_TO_STATE[key];
    // Case-insensitive fallback
    const lc = key.toLowerCase();
    for (const [k, v] of Object.entries(CITY_TO_STATE)) {
        if (k.toLowerCase() === lc) return v;
    }
    return "";
}
